// tslint:disable
// this is an auto generated file. This will be overwritten

export const getUserUploadedFiles = /* GraphQL */ `
  query GetUserUploadedFiles($id: ID!) {
    getUserUploadedFiles(id: $id) {
      id
      userId
      name
      url
      uploadedAt
    }
  }
`;
export const listUserUploadedFiless = /* GraphQL */ `
  query ListUserUploadedFiless(
    $filter: ModelUserUploadedFilesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserUploadedFiless(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        name
        url
        uploadedAt
      }
      nextToken
    }
  }
`;
export const getUserFavouriteDeal = /* GraphQL */ `
  query GetUserFavouriteDeal($id: ID!) {
    getUserFavouriteDeal(id: $id) {
      id
      type
      userId
      dealId
      brandSlug
      active
      addedAt
      deactivatedAt
    }
  }
`;
export const listUserFavouriteDeals = /* GraphQL */ `
  query ListUserFavouriteDeals(
    $filter: ModelUserFavouriteDealFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserFavouriteDeals(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        userId
        dealId
        brandSlug
        active
        addedAt
        deactivatedAt
      }
      nextToken
    }
  }
`;
export const getUserPopupAnswers = /* GraphQL */ `
  query GetUserPopupAnswers($id: ID!) {
    getUserPopupAnswers(id: $id) {
      id
      popupId
      username
      firstName
      lastName
      email
      mobile
      addressline1
      addressline2
      suburb
      state
      postcode
      product
      question
      answer
      answeredAt
    }
  }
`;
export const listUserPopupAnswerss = /* GraphQL */ `
  query ListUserPopupAnswerss(
    $filter: ModelUserPopupAnswersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserPopupAnswerss(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        popupId
        username
        firstName
        lastName
        email
        mobile
        addressline1
        addressline2
        suburb
        state
        postcode
        product
        question
        answer
        answeredAt
      }
      nextToken
    }
  }
`;
